export default "__VITE_ASSET__0ed6b657__"